// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-page {
  max-width: 46rem;
  margin: 0 auto;
  padding: 2.25rem 1.5rem 4rem;
}

.legal-container {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

.legal-title {
  margin: 0 0 1.5rem;
}

.legal-section {
  padding: 1.25rem 0;
  border-top: 1px solid var(--border-primary);
}

.legal-section h2 {
  margin: 0 0 0.6rem;
  font-size: clamp(1.25rem, 3vw, 1.5rem);
}

.legal-section h3 {
  margin: 1.1rem 0 0.4rem;
  font-size: 1.02rem;
}

.legal-section p {
  margin: 0 0 0.75rem;
  color: var(--text-secondary);
  overflow-wrap: anywhere;
}

.legal-section ul {
  margin: 0 0 0.75rem;
  padding-left: 1.2rem;
  color: var(--text-secondary);
}

.legal-section a {
  color: var(--accent-primary);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.legal-contact {
  margin-top: 1rem;
  padding-top: 1.25rem;
  border-top: 2px solid var(--text-primary);
}

.legal-contact h3 {
  margin: 0 0 0.5rem;
}

.legal-contact p {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.88rem;
}

@media (max-width: 680px) {
  .legal-page {
    padding: 1.5rem 1rem 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/legal/LegalPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".legal-page {\n  max-width: 46rem;\n  margin: 0 auto;\n  padding: 2.25rem 1.5rem 4rem;\n}\n\n.legal-container {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.legal-title {\n  margin: 0 0 1.5rem;\n}\n\n.legal-section {\n  padding: 1.25rem 0;\n  border-top: 1px solid var(--border-primary);\n}\n\n.legal-section h2 {\n  margin: 0 0 0.6rem;\n  font-size: clamp(1.25rem, 3vw, 1.5rem);\n}\n\n.legal-section h3 {\n  margin: 1.1rem 0 0.4rem;\n  font-size: 1.02rem;\n}\n\n.legal-section p {\n  margin: 0 0 0.75rem;\n  color: var(--text-secondary);\n  overflow-wrap: anywhere;\n}\n\n.legal-section ul {\n  margin: 0 0 0.75rem;\n  padding-left: 1.2rem;\n  color: var(--text-secondary);\n}\n\n.legal-section a {\n  color: var(--accent-primary);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.legal-contact {\n  margin-top: 1rem;\n  padding-top: 1.25rem;\n  border-top: 2px solid var(--text-primary);\n}\n\n.legal-contact h3 {\n  margin: 0 0 0.5rem;\n}\n\n.legal-contact p {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 0.88rem;\n}\n\n@media (max-width: 680px) {\n  .legal-page {\n    padding: 1.5rem 1rem 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
